namespace $ { $mol_style_attach( "bog/bzrl/app/gap/gap.css",
 ":root {\n\t--mol_gap_roundMore: 1.25rem;\n}\n"
) }